// Section 9: the building registry. Keys are building type ids; BuildingTypeId is derived
// from config.buildings.
import type { Config } from '../../config';
import { checkRegistryKeys, type BuildingDef } from '../../core/registry';
import type { BuildingTypeId } from '../../core/types';
import { cemetery } from './cemetery';
import { cistern } from './cistern';
import { clinic } from './clinic';
import { commonHall } from './common-hall';
import { field } from './field';
import { granary } from './granary';
import { house } from './house';
import { jail } from './jail';
import { palisade } from './palisade';
import { school } from './school';
import { shelter } from './shelter';
import { watchPost } from './watch-post';
import { well } from './well';
import { woodshed } from './woodshed';
import { workshop } from './workshop';

/** Build the buildings registry for a config (content numbers come from the config, ADR-0008). */
export function buildBuildings(config: Config) {
  const buildings = Object.freeze({
    shelter: shelter(config),
    house: house(config),
    field: field(config),
    granary: granary(config),
    well: well(config),
    cistern: cistern(config),
    woodshed: woodshed(config),
    workshop: workshop(config),
    clinic: clinic(config),
    school: school(config),
    'watch-post': watchPost(config),
    palisade: palisade(config),
    'common-hall': commonHall(config),
    cemetery: cemetery(config),
    jail: jail(config),
  } satisfies Record<BuildingTypeId, BuildingDef>);
  checkRegistryKeys('buildings', buildings);
  return buildings;
}
